import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import { useTranslation } from "react-i18next";

function SmartHomePage() {
    const { t } = useTranslation();
    const directory= "/images/smartHome/";
    const filenames=[
        'VPR02630_Vasso_Paraschi.webp',
        'VPR02896_Vasso_Paraschi.webp',
        'VPR03183_Vasso_Paraschi.webp',
        'VPR03195_Vasso_Paraschi.webp',
        'VPR03197_Vasso_Paraschi.webp',
        'VPR03212_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Smart Home")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default SmartHomePage;
